export default "__VITE_ASSET__DFSvsZJu__"